module.exports = __webpack_public_path__ + "static/media/back.e30dd771.png";